module.exports = __webpack_public_path__ + "static/a-xx-225-art-9e15b69b7bbcbf9e846596ed5988591e.jpg";